export default __webpack_public_path__ + "static/media/MBCorpoATitle-Regular_0.bd8a45ab.otf";